import React, { useState, useEffect } from "react"
import DealerInventoryPanelComponent from "./dealerInventoryPanel.component"
import { useSelector } from "react-redux"
import { getLang } from "app/feature/constants"

function DealerInventoryPanelContainer() {
  const lang = useSelector(state => state.constant.languages)
  const [activeIndex, setActiveIndex] = useState(null)
  const query = new URLSearchParams(window.location.search)

  let tabLabels = [
    getLang(lang, "label.PRODUCT_TAB"), 
    getLang(lang, "label.PACKAGE_TAB"), 
    getLang(lang, "label.BOX_TAB"), 
    getLang(lang, "label.LOOSE_ITEM_TAB"), 
  ]
  
  let type = query.get("type")

  const typeList = [
    "product",
    "package",
    "box",
    "loose-item"
  ]

  useEffect(() => {
    let tempIndex = typeList.findIndex(t => t === type)
    setActiveIndex(tempIndex >= 0 ? tempIndex : 0)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type])

  const handleChange = (event, index) => {
    if (activeIndex !== index) {
      setActiveIndex(index)
      type = query.get("type")
      window.history.replaceState({}, '', `?tab=inventory&type=${typeList[index]}`)
    }
  }

  return (
    <DealerInventoryPanelComponent 
      tabLabels={tabLabels}
      activeIndex={activeIndex}
      handleChange={handleChange}
      lang={lang}
    />
  )
}

export default DealerInventoryPanelContainer
